/**
 * Environment configuration for Guestflow
 * Centralizes all URLs for easy domain migration
 */
export const env = {
    // API URLs
    api: {
        local: "http://localhost:8787",
        dev: "https://guestflow-api.meals.workers.dev",
        prod: process.env.VITE_API_URL || "https://api.guestflow.fit",
    },
    // App URLs
    app: {
        local: "http://localhost:5173",
        dev: process.env.VITE_APP_URL || "https://c06dedfe.guestflow-app.pages.dev",
        prod: "https://app.guestflow.fit",
    },
    // Landing URLs
    landing: {
        local: "http://localhost:4321",
        dev: "https://b42a1cb8.guestflow.pages.dev",
        prod: "https://guestflow.fit",
    },
};
/**
 * Get the API URL for the current environment
 */
export function getApiUrl(mode = "prod") {
    return env.api[mode];
}
/**
 * Get the App URL for the current environment
 */
export function getAppUrl(mode = "prod") {
    return env.app[mode];
}
/**
 * Get the Landing URL for the current environment
 */
export function getLandingUrl(mode = "prod") {
    return env.landing[mode];
}
/**
 * Detect the current environment based on hostname
 */
export function detectEnvMode() {
    if (typeof window === "undefined")
        return "local";
    const hostname = window.location.hostname;
    if (hostname === "localhost" || hostname === "127.0.0.1")
        return "local";
    if (hostname.includes("pages.dev") || hostname.includes("workers.dev"))
        return "dev";
    return "prod";
}
/**
 * Get the appropriate URL for the current environment
 */
export const currentApiUrl = () => getApiUrl(detectEnvMode());
export const currentAppUrl = () => getAppUrl(detectEnvMode());
export const currentLandingUrl = () => getLandingUrl(detectEnvMode());
